export enum RichLogCommaMode {
  Or = "OR",
  And = "AND",
}
